import { logger } from '@parrot-software/observability';

import type { IInvoiceDataApiPort } from '@subscriptions/application/ports';
import type { FiscalRegimesDto } from '@subscriptions/application/dtos';
import { extractErrorAttributes } from '@subscriptions/application/utils';

const invoiceLog = logger.forDomain('SUB', { subdomain: 'billing' });

/**
 * Use case for listing fiscal regimes catalog from SAT.
 *
 * @param port - Invoice data API port
 * @returns Use case executor
 */
export const listFiscalRegimesUseCase = (port: IInvoiceDataApiPort) => {
  const execute = async (): Promise<FiscalRegimesDto> => {
    try {
      return await port.listFiscalRegimes();
    } catch (error) {
      invoiceLog.error('listFiscalRegimes', extractErrorAttributes(error));
      throw error;
    }
  };

  return { execute };
};
